module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "font-sans leading-tight",
    attrs: {
      "id": "app"
    }
  }, [_c('StudentMap', {
    attrs: {
      "markers": _vm.profiles
    },
    on: {
      "mapMoved": _vm.mapMoved,
      "markerClicked": _vm.pointClicked
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showMobileHelpers) ? _c('div', {
    staticClass: "absolute pin-b pin-l pin-r z-20 md:hidden"
  }, [_c('div', {
    staticClass: "bg-brand p-2 text-white text-center font-bold shadow flex justify-between"
  }, [_c('csf-button', {
    staticClass: "inline-block pointer-events-auto",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addYourself
    }
  }, [_vm._v("Add yourself")]), _vm._v(" "), _c('csf-button', {
    on: {
      "click": _vm.showRandom
    }
  }, [_vm._v("View random")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "absolute pin-r pin-b pin-t pin-b pin-l p-8"
  }, [_c('router-view', {
    key: _vm.$route.fullPath,
    on: {
      "showRandom": _vm.showRandom
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d0fd1a8","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/views/App.vue
// module id = 171
// module chunks = 0